import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_AGENT_LOG = "GET_LIST_AGENT_LOG";
export const GET_LIST_AGENT_LOG_ERROR = "GET_LIST_AGENT_LOG_ERROR";
export const GET_LIST_AGENT_LOG_SUCCESS = "GET_LIST_AGENT_LOG_SUCCESS";

export const COUNT_LIST_AGENT_LOG = "COUNT_LIST_AGENT_LOG";
export const COUNT_LIST_AGENT_LOG_ERROR = "COUNT_LIST_AGENT_LOG_ERROR";
export const COUNT_LIST_AGENT_LOG_SUCCESS = "COUNT_LIST_AGENT_LOG_SUCCESS";

export const ADD_NEW_AGENT_LOG = "ADD_NEW_AGENT_LOG";
export const ADD_NEW_AGENT_LOG_ERROR = "ADD_NEW_AGENT_LOG_ERROR";
export const ADD_NEW_AGENT_LOG_SUCCESS = "ADD_NEW_AGENT_LOG_SUCCESS";

export const EDIT_A_AGENT_LOG = "EDIT_A_AGENT_LOG";
export const EDIT_A_AGENT_LOG_SUCCESS = "EDIT_A_AGENT_LOG_SUCCESS";
export const EDIT_A_AGENT_LOG_ERROR = "EDIT_A_AGENT_LOG_ERROR";

export const DELETE_A_AGENT_LOG = "DELETE_A_AGENT_LOG";
export const DELETE_A_AGENT_LOG_SUCCESS = "DELETE_A_AGENT_LOG_SUCCESS";
export const DELETE_A_AGENT_LOG_ERROR = "DELETE_A_AGENT_LOG_ERROR";

/**
 * Reducer
 */

const initialState = {
  agentLogs: [],
  error: false,
  count: 0,
  loading: false,
};

export const agentLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_AGENT_LOG:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_AGENT_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        agentLogs: action.payload,
      };
    case GET_LIST_AGENT_LOG_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_AGENT_LOG:
      return {
        ...state,
      };
    case COUNT_LIST_AGENT_LOG_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_AGENT_LOG_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_AGENT_LOG:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_AGENT_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        agentLog: action.payload,
      };
    case ADD_NEW_AGENT_LOG_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_AGENT_LOG:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_AGENT_LOG_SUCCESS: {
      const newItems = state.agentLogs.filter(
        (item) => item.id !== action.data.id
      );
      return {
        ...state,
        loading: false,
        newItems,
      };
    }
    case EDIT_A_AGENT_LOG_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_AGENT_LOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_AGENT_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        agentLog: action.payload,
      };
    case DELETE_A_AGENT_LOG_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListAgentLogs = (order, limit, skip, where) => ({
  type: GET_LIST_AGENT_LOG,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListAgentLogs = (where) => ({
  type: COUNT_LIST_AGENT_LOG,
  data: {
    where,
  },
});

export const addNewAgentLogs = (name, color, note) => ({
  type: ADD_NEW_AGENT_LOG,
  data: {
    name,
    color,
    note,
  },
});

export const editAgentLogs = (id, name, color, note) => ({
  type: EDIT_A_AGENT_LOG,
  data: {
    id,
    name,
    color,
    note,
  },
});

export const deleteAgentLogs = (id) => ({
  type: DELETE_A_AGENT_LOG,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListAgentLogs,
      countListAgentLogs,
      addNewAgentLogs,
      editAgentLogs,
      deleteAgentLogs,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListAgentLogsApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("call-center/agent-log", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListAgentLogsApi = (where) => {
  return apiCaller.getData("call-center/agent-log/count", { ...where });
};
const addNewAgentLogsApi = (name, color, note) => {
  return apiCaller.post("call-center/agent-log", { name, color, note });
};
const editAgentLogsApi = (id, name, color, note) => {
  return apiCaller.put(`call-center/agent-log/${id}`, { name, color, note });
};
const deleteAgentLogsApi = (id) => {
  return apiCaller.del(`call-center/agent-log/${id}`);
};

/**
 * sagas
 */

export const getListAgentLogsFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_AGENT_LOG);
    try {
      const res = yield call(
        getListAgentLogsApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_AGENT_LOG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_AGENT_LOG_ERROR, error });
    }
  }
};

export const countAgentLogsFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_AGENT_LOG);
    try {
      const res = yield call(countListAgentLogsApi, action.data.where);
      yield put({
        type: COUNT_LIST_AGENT_LOG_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_AGENT_LOG_ERROR, error });
    }
  }
};

export const addNewAgentLogsFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_AGENT_LOG);
    try {
      const res = yield call(
        addNewAgentLogsApi,
        action.data.name,
        action.data.color,
        action.data.note
      );
      yield put({ type: ADD_NEW_AGENT_LOG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_NEW_AGENT_LOG_ERROR, error });
    }
  }
};

export const editAgentLogsFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_AGENT_LOG);
    try {
      const res = yield call(
        editAgentLogsApi,
        action.data.id,
        action.data.name,
        action.data.color,
        action.data.note
      );
      yield put({ type: EDIT_A_AGENT_LOG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_AGENT_LOG_ERROR, error });
    }
  }
};

export const deleteAgentLogsFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_AGENT_LOG);
    try {
      const res = yield call(deleteAgentLogsApi, action.data.id);
      yield put({ type: DELETE_A_AGENT_LOG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_AGENT_LOG_ERROR, error });
    }
  }
};
